// extracted by mini-css-extract-plugin
export default {"cloading":"loadingComponent_cloading__8Z4li","logined":"loadingComponent_logined__Nwbn7","show":"loadingComponent_show__KZsZo"};